import { useEffect, useRef, useState } from 'react'
import config from 'src/config/config';
import { withAppContext } from 'src/store/initAppContext';
import styled from 'styled-components';
import { ethers } from "ethers";
import { metaMaskAuthCrypto, telegramAuthCrypto } from 'src/config/api';
import Intl from "src/components/common/Intl";
import { AppEnvConfig } from "src/config/envConfig";


declare global {
    interface Window {
      onTelegramAuth: (user: any) => void;
      ethereum: any;
    }
  }

const Google = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M4.72886 9.99193C4.72755 11.2873 5.18456 12.5414 6.01901 13.5322C6.85345 14.523 8.01152 15.1866 9.28824 15.4056C10.565 15.6246 11.878 15.3849 12.9949 14.7288C14.1119 14.0728 14.9607 13.0427 15.3912 11.821H10.216V8.1629H19.1828V11.821H19.1782C18.3305 15.9948 14.6404 19.1371 10.216 19.1371C5.16509 19.1371 1.0708 15.0428 1.0708 9.99193C1.0708 4.94106 5.16509 0.846774 10.216 0.846774C11.7108 0.845709 13.183 1.21144 14.5035 1.91188C15.824 2.61232 16.9525 3.62608 17.79 4.86424L14.7922 6.96306C14.1414 5.97941 13.191 5.23163 12.0819 4.83055C10.9728 4.42948 9.76391 4.39645 8.63452 4.73638C7.50514 5.0763 6.51534 5.77108 5.81184 6.71773C5.10834 7.66437 4.72859 8.8125 4.72886 9.99193Z" fill="white" />
        </svg>
    )
}

const Twitter = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <mask id="mask0_36_5585" maskUnits="userSpaceOnUse" x="2" y="1" width="18" height="18">
                <path d="M2.06543 1.04541H19.9432V18.9232H2.06543V1.04541Z" fill="white" />
            </mask>
            <g mask="url(#mask0_36_5585)">
                <path d="M16.1442 1.88309H18.8858L12.8968 8.74559L19.9432 18.0854H14.4266L10.1028 12.422L5.16084 18.0854H2.4166L8.82195 10.7428L2.06543 1.88436H7.72246L11.6249 7.05998L16.1442 1.88309ZM15.18 16.4407H16.6997L6.89243 3.44228H5.26299L15.18 16.4407Z" fill="white" />
            </g>
        </svg>

    )
}

const Line = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
      <path d="M22.9998 10.0515C22.9998 5.03952 17.9753 0.96167 11.7997 0.96167C5.62412 0.96167 0.599609 5.03952 0.599609 10.0515C0.599609 14.545 4.58382 18.3076 9.96689 19.0191C10.3323 19.0979 10.8279 19.26 10.9535 19.5718C11.0666 19.855 11.0277 20.298 10.9901 20.5847C10.9901 20.5847 10.8587 21.3749 10.8302 21.5439C10.7811 21.8271 10.6052 22.6516 11.8008 22.148C12.9964 21.6444 18.2516 18.3499 20.6006 15.6447C22.2221 13.8632 22.9998 12.0567 22.9998 10.0515ZM7.84746 12.727C7.84746 12.8481 7.7504 12.9451 7.62935 12.9451H4.49132C4.43308 12.9451 4.37941 12.9223 4.34058 12.8846C4.33944 12.8835 4.3383 12.8823 4.33716 12.8812C4.33602 12.88 4.33487 12.8789 4.33373 12.8777C4.29605 12.8389 4.27321 12.7853 4.27321 12.727V7.84753C4.27321 7.72648 4.37142 7.62942 4.49132 7.62942H5.27697C5.39687 7.62942 5.49508 7.72763 5.49508 7.84753V11.7233H7.62935C7.74926 11.7233 7.84746 11.8215 7.84746 11.9414V12.727ZM9.74193 12.727C9.74193 12.8469 9.64372 12.9451 9.52382 12.9451H8.73817C8.61827 12.9451 8.52006 12.8481 8.52006 12.727V7.84753C8.52006 7.72763 8.61827 7.62942 8.73817 7.62942H9.52382C9.64372 7.62942 9.74193 7.72763 9.74193 7.84753V12.727ZM15.149 12.727C15.149 12.8469 15.0519 12.9451 14.9309 12.9451H14.1452C14.1258 12.9451 14.1075 12.9428 14.0893 12.9383C14.0881 12.9383 14.087 12.9371 14.0858 12.9371C14.0813 12.936 14.0767 12.9337 14.071 12.9326C14.0687 12.9314 14.0664 12.9314 14.0641 12.9303C14.0607 12.9291 14.0573 12.9269 14.0539 12.9257C14.0504 12.9246 14.047 12.9223 14.0436 12.9211C14.0413 12.92 14.039 12.9189 14.0379 12.9177C14.0333 12.9154 14.0287 12.912 14.0242 12.9097C14.023 12.9086 14.023 12.9086 14.0219 12.9074C14.0013 12.8937 13.9819 12.8755 13.9659 12.8538L11.7278 9.82878V12.727C11.7278 12.8469 11.6295 12.9451 11.5096 12.9451H10.724C10.6029 12.9451 10.5059 12.8481 10.5059 12.727V7.84753C10.5059 7.72763 10.6041 7.62942 10.724 7.62942H11.5096C11.5119 7.62942 11.5142 7.62942 11.5176 7.62942C11.5211 7.62942 11.5245 7.62942 11.5291 7.63056C11.5325 7.63056 11.537 7.63056 11.5405 7.6317C11.5439 7.6317 11.5462 7.63285 11.5496 7.63285C11.5542 7.63399 11.5576 7.63513 11.5622 7.63513C11.5645 7.63627 11.5679 7.63627 11.5702 7.63741C11.5747 7.63856 11.5793 7.6397 11.5827 7.64198C11.585 7.64312 11.5873 7.64427 11.5896 7.64427C11.5941 7.64541 11.5976 7.64769 11.6021 7.64998C11.6044 7.65112 11.6067 7.65226 11.609 7.6534C11.6124 7.65568 11.617 7.65797 11.6204 7.66025C11.6227 7.66139 11.625 7.66254 11.6273 7.66368C11.6307 7.66596 11.6341 7.66825 11.6387 7.67167C11.641 7.67281 11.6421 7.67396 11.6444 7.67624C11.649 7.67967 11.6524 7.68195 11.6558 7.68538C11.657 7.68652 11.6592 7.68766 11.6604 7.6888C11.6649 7.69337 11.6695 7.69679 11.6741 7.7025L11.6752 7.70365C11.6809 7.7105 11.6878 7.71735 11.6924 7.72534L13.9294 10.7458V7.84753C13.9294 7.72763 14.0265 7.62942 14.1475 7.62942H14.9332C15.0542 7.62942 15.1513 7.72763 15.1513 7.84753V12.727H15.149ZM19.4872 8.63318C19.4872 8.75422 19.3901 8.85129 19.2691 8.85129H17.1348V9.67577H19.2691C19.3901 9.67577 19.4872 9.77397 19.4872 9.89388V10.6795C19.4872 10.8006 19.3901 10.8976 19.2691 10.8976H17.1348V11.7233H19.2691C19.3901 11.7233 19.4872 11.8215 19.4872 11.9414V12.727C19.4872 12.8469 19.3901 12.9451 19.2691 12.9451H16.131C16.0728 12.9451 16.0191 12.9223 15.9803 12.8846C15.9792 12.8835 15.978 12.8823 15.9769 12.8812C15.9757 12.88 15.9746 12.8789 15.9735 12.8777C15.9358 12.8389 15.9129 12.7853 15.9129 12.727V7.84753C15.9129 7.78929 15.9358 7.73676 15.9735 7.69679C15.9746 7.69565 15.9757 7.69451 15.9769 7.69337C15.978 7.69223 15.978 7.69223 15.9792 7.69108C16.018 7.6534 16.0717 7.62942 16.1299 7.62942H19.2679C19.389 7.62942 19.486 7.72763 19.486 7.84753V8.63318H19.4872Z" fill="white"/>
      </svg>
    )
}

const TelegramIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
    <path d="M19.9362 4.51976L16.9062 18.7048C16.6802 19.7038 16.1002 19.9288 15.2622 19.4778L10.7172 16.1258L8.49216 18.2528C8.26716 18.4788 8.04116 18.7048 7.52516 18.7048L7.88016 14.0298L16.3582 6.32576C16.7122 5.97076 16.2612 5.84176 15.8102 6.13276L5.26916 12.7728L0.723157 11.3868C-0.275843 11.0648 -0.275843 10.3868 0.949157 9.93676L18.6142 3.06976C19.4842 2.81176 20.2262 3.26376 19.9362 4.51976Z" fill="white"/>
    </svg>
  )
}

// const MetaMaskIcon = () => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//     <path d="M20.2688 19.6669L15.8104 18.3662L12.4479 20.335H10.102L6.73719 18.3662L2.2811 19.6657L0.925293 15.1843L2.2811 10.2084L0.925293 6.00073L2.2811 0.786804L9.24526 4.86226H13.3046L20.2688 0.786804L21.6246 6.00073L20.2688 10.2073L21.6246 15.1843L20.2688 19.6669Z" fill="#FF5C16"/>
//     <path d="M2.28223 0.786804L9.24524 4.86571L8.96925 7.66472L2.28223 0.786804ZM6.73832 15.1843L9.80297 17.4727L6.73832 18.3662V15.1843ZM9.55803 11.4055L8.96925 7.66702L5.19968 10.2084H5.19738V10.2096L5.20888 12.8257L6.73832 11.4055H9.55803ZM20.2676 0.786804L13.3034 4.86571L13.5794 7.66472L20.2676 0.786804ZM15.8115 15.1843L12.7469 17.4727L15.8115 18.3662V15.1843ZM17.3513 10.2096L13.5806 7.66817L12.9918 11.4055H15.8104L17.3398 12.8269L17.3513 10.2096Z" fill="white"/>
//     <path d="M6.73719 18.3662L2.2811 19.6657L0.925293 15.1866H6.73719V18.3662ZM9.5569 11.4044L10.4079 16.8092L9.22801 13.8032L5.2066 12.8257L6.73604 11.4044H9.5569ZM15.8127 18.3662L20.2688 19.6657L21.6246 15.1866H15.8115L15.8127 18.3662ZM12.993 11.4044L12.142 16.8092L13.3219 13.8032L17.3433 12.8257L15.8127 11.4044H12.993Z" fill="#EDEDED"/>
//     <path d="M0.925293 15.1843L2.2811 10.2073H5.19625L5.20775 12.8246L9.22801 13.802L10.4079 16.8069L9.80184 17.4693L6.73719 15.182H0.925293V15.1843ZM21.6246 15.1843L20.2688 10.2073H17.3536L17.3421 12.8246L13.3219 13.802L12.142 16.8069L12.748 17.4693L15.8127 15.182H21.6246V15.1843ZM13.3046 4.86224H9.24526L8.96927 7.6624L10.4079 16.8046H12.142L13.5818 7.6624L13.3046 4.86224Z" fill="#CFCFCF"/>
//     <path d="M2.2811 0.786804L0.925293 6.00073L2.2811 10.2073H5.19625L8.96812 7.66472L2.2811 0.786804ZM8.71397 12.49H7.39382L6.67394 13.1799L9.22916 13.8009L8.71397 12.49ZM20.2688 0.786804L21.6246 6.00073L20.2688 10.2073H17.3536L13.5818 7.66472L20.2688 0.786804ZM13.837 12.49H15.1595L15.8794 13.1799L13.3219 13.8021L13.837 12.49ZM12.4467 18.5514L12.748 17.4704L12.142 16.8092H10.4067L9.80069 17.4704L10.102 18.5514" fill="#676767"/>
//     <path d="M12.448 18.5514V20.3361H10.1021V18.5514H12.448Z" fill="#C0C4CD"/>
//     <path d="M6.73828 18.364L10.1042 20.335V18.5503L9.80293 17.4693L6.73828 18.364ZM15.8115 18.364L12.4478 20.3362V18.5514L12.7491 17.4704L15.8115 18.364Z" fill="#E7EBF6"/>
//     </svg>
//   )
// }

function SocialmediaLogin(props: any) {
    const {
        app: { brandId, currENV }
    } = props;

    
    const envData = AppEnvConfig[currENV as 'DEV' | 'STAGING' | 'PRE-PROD' | 'PROD' ] || AppEnvConfig.DEV;

    const [origin, setOrigin] = useState('');
    const [showWidget, setShowWidget] = useState(false);
    const widgetRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const _origin = window.location.origin;
        setOrigin(_origin);
    }, [])


    const handleTelegramLogin = () => {
        const botId = envData.telegramBotId; // e.g., '7773280241'
        const origin = window.location.origin;
        const returnTo = `${origin}${window.location.pathname}`; // or a specific callback route

        const telegramOAuthUrl = `https://oauth.telegram.org/auth?bot_id=${botId}&origin=${encodeURIComponent(
            origin
        )}&embed=1&request_access=write&return_to=${encodeURIComponent(returnTo)}`;

        window.location.href = telegramOAuthUrl;
    };

  useEffect(() => {
    // 1. Define the global callback for Telegram login
    if(showWidget){
 
      window.onTelegramAuth = function (user) {

        const params = {
          brand_id: brandId,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          hash: user.hash,
          id: user.id,
          auth_date: user.auth_date,
          domain: origin,
        };

          telegramAuthCrypto(params).then(response => {
            const { response_url } = response?.data?.data;
        
            if (response_url) {
              window.location.href = response_url;
            } else {
              console.error("Login failed.");
            }
          })
          .catch(error => {
            console.error('Error sending Telegram user to backend:', error);
          });
        };

    // 2. Create Telegram widget script dynamically
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', envData.telegramBotName); // 🔁 your bot username (no @)
    script.setAttribute('data-size', 'small');
    script.setAttribute('data-userpic', 'false');
    script.setAttribute('data-radius', '10');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-auth-url', `${config.affiliateApiUrl}/user/telegram_auth_callback?brand_id=${brandId}&domain=${origin}`);
    script.async = true;

   // 3. Inject the script into the div
    if (widgetRef.current) {
        widgetRef.current.innerHTML = ''
        widgetRef.current.appendChild(script); 
      }
    }
  }, [showWidget]);



    //for metamask
    // const handleMetaMaskLogin = async () => {
    //     if (!window.ethereum) {
    //       alert("Please Install MetaMask");
    //       return;
    //     }
      
    //     // Ethers v5: Use Web3Provider
    //     const provider = new ethers.providers.Web3Provider(window.ethereum);
      
    //     // Prompt user to connect wallet
    //     await provider.send("eth_requestAccounts", []);
      
    //     const signer = provider.getSigner();
    //     const address = await signer.getAddress();
      
    //     const message = "Login to Yolo247";
    //     const signature = await signer.signMessage(message);    

    //     try {
    //       const params = {
    //         wallet_address: address,
    //         message,
    //         signature,
    //       };
        
    //       const response = await metaMaskAuthCrypto(params, brandId, origin); // 👈 Remove extra wrapping
        
    //       const responseUrl = response?.data?.data?.response_url;
        
    //       if (responseUrl) {
    //         window.location.href = responseUrl;
    //       } else {
    //         console.error("Login failed — response URL missing.");
    //       }
    //     } catch (error) {
    //       console.error("Login request failed:", error);
    //     }          
    //   };


    //for Crypto whitelable
    const _googleparam = encodeURIComponent(`${config.affiliateApiUrl}/user/google_auth_callback?brand_id=${brandId}&domain=${origin}`);
    const _twitterparam = encodeURIComponent(`${config.affiliateApiUrl}/user/twitter_auth_callback?brand_id=${brandId}&domain=${origin}`);
    const _lineparam = encodeURIComponent(`${config.affiliateApiUrl}/user/line_auth_callback?brand_id=${brandId}&domain=${origin}`);

    const _D = new Date()
    const _time = Date.now();
    const _rendomString = _D.toUTCString();
    return (
        <Container>
            <Heading><Intl langKey="LOGIN@LoginDirectly" /></Heading>
            <BoxWrapper>

                <Box href={`https://accounts.google.com/o/oauth2/v2/auth?client_id=${envData.googleClientId}&response_type=code&redirect_uri=${_googleparam}&scope=email%20profile&access_type=online&prompt=consent`}><Google /></Box>

                <Box href={`https://x.com/i/oauth2/authorize?response_type=code&client_id=${envData.xClientId}
&redirect_uri=${_twitterparam}&scope=tweet.read%20users.read%20users.email&state=state&code_challenge=challenge&code_challenge_method=plain`}><Twitter /></Box>
                
                <Box href={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${envData.lineClientId}&redirect_uri=${_lineparam}&state=${_rendomString}&scope=profile%20openid%20email&nonce=${_time}`}><Line /></Box>
                                
                <Box onClick={() => handleTelegramLogin()}><TelegramIcon/></Box>
                {/* <Box onClick={() => handleMetaMaskLogin()}><MetaMaskIcon/></Box> */}
                {/* {showWidget && <TelegramWidgetWrap ref={widgetRef}></TelegramWidgetWrap>} */}
            </BoxWrapper>
        </Container>
    )
}

export default withAppContext(SocialmediaLogin);


//styled component
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color:#fff;
`;

const Heading = styled.p`
    padding: 15px 10px;
    padding-top: 20px;
    margin: 0;
    font-size: 12px;
    position: relative;
    text-transform: capitalize;

    &::after{
        content: '';
        position: absolute;
        border-top: 2px solid #585858;
        width: 100px;
        margin-left: 10px;
        top: 50%;
    }

    &::before{
        content: '';
        position: absolute;
        border-top: 2px solid #585858;
        width: 100px;
        top: 50%;
        left: -100px;
    }
`;

const BoxWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    position: relative;
`;

const Box = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    border: 0.268px solid #4F4F4F;
    background: #232626;
    cursor: pointer;
    &:hover, &:active {
        color:#fff
    }

    &:hover {
        border: 1px solid #fff;
    }
`;

const TelegramWidgetWrap = styled.div`
    position: absolute;
    bottom: -24px;
    z-index: 99999;
    right: 0;
`;
